export const PARAM_EXC_LOGIN = 'exc-login';
export const OMEGA_SCRIPT_STAGE = 'https://assets.adobedtm.com/98fab992275ef6366cc65f57f86b1e895a66c912/satelliteLib-9677dd89e95ab9b85bc5c114aab2dc1af2d6502d-staging.js';
export const OMEGA_SCRIPT_PROD = 'https://assets.adobedtm.com/98fab992275ef6366cc65f57f86b1e895a66c912/satelliteLib-9677dd89e95ab9b85bc5c114aab2dc1af2d6502d.js';
export const NOOP = function(...args) {
  return { ...args };
};



// WEBPACK FOOTER //
// ./src/constants/genericConstants.js